// extracted by mini-css-extract-plugin
module.exports = {"menu":"LpMJqfN4pSsWK7B-74-qJ"};